
import { Component, Prop, BaseMixins, Watch } from "@/lib";
import QueryBar from "./component/query-bar.vue";
import QueryResult from "./component/query-result.vue";
import QueryFooter from "./component/query-footer.vue";
import SectionButton from "./component/section-button.vue";

@Component({ name: "search-page", components: { QueryBar, QueryResult, QueryFooter, SectionButton } })
export default class SearchPage extends BaseMixins {
  /*查询模型*/
  @Prop({ type: Object }) model: any;
  /*列数组*/
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  cols: Array<any>;
  /*页数配置*/
  @Prop({ type: Array }) pageSizeOptions: Array<any>;
  /*查询dispatch type     module/menu/action*/
  @Prop({ type: String, required: true }) queryAction: string;
  /*导出 - 若不指定，则使用默认统一方法进行导出操作*/
  @Prop({ type: String }) exportAction: string;
  /*不显示导出按钮*/
  @Prop({ type: Boolean, default: false }) exportEnabled: boolean;
  /*导出后台接口地址*/
  @Prop({ type: String }) exportApi: string;
  /*导出按钮大小*/
  @Prop({type:String}) exportButtonSize:string;
  /*store table name 默认根据query解析*/
  @Prop({ type: String }) resultFieldName: string;
  /*页面加载自动查询*/
  @Prop({ type: Boolean, default: true }) isAutoQuery: boolean;
  /*查询页面组件的名称-影响refs和slot名称*/
  @Prop({ type: String, default: "" }) prefixName: string;
  /*是否显示 checkbox*/
  @Prop({ type: Boolean, default: false }) selection: boolean;
  /*是否fixed*/
  @Prop({ type: Boolean, default: false }) fixed: boolean;

    /*是否显示间隔斑马纹*/
  @Prop({ type: Boolean, default: false }) stripe: boolean;

  @Prop({ type: Number, default: 150 }) labelWidth: number;

  /*结果序号宽度*/
  @Prop({ type: Number, default: 60 }) indexWidth: number;
  @Prop({type:Function}) summaryMethod:any;
 /*自定义排序*/
 @Prop({type:Function}) sortion:any;

  _pageRouteName = "";

  activated() {
    this._pageRouteName = this.$route.name as string;
  }

  get componentPrefix() {
    if (this.prefixName) {
      return this.prefixName + "-";
    }
    return this.prefixName;
  }
  get $refsQueryBarName() {
    return `${this.componentPrefix}querybar`;
  }

  /*默认为：querybar-buttons*/
  get queryBarButtonSlotName() {
    return this.$refsQueryBarName + "-buttons";
  }

  get queryBarAdvanceName() {
    return this.$refsQueryBarName + "-advance";
  }

  /*默认为：section-buttons*/
  get sectionButtonSlotName() {
    return this.prefixName + "section-buttons";
  }

  /*默认为：top-info*/
  get resultTopInfoSlotName() {
    return this.prefixName + "top-info";
  }

  get tableClass() {
    if (this.$slots[this.sectionButtonSlotName] || this.$slots[this.resultTopInfoSlotName] || this.exportEnabled) {
      return "margin-top-10";
    }
    return "";
  }

  /*刷新*/
  refresh() {
    (this.$refs[this.$refsQueryBarName] as any).refresh();
  }

  selectionChange(selection) {
    this.$emit("on-selection-change", selection);
  }
//sortChange(sortion) {
  //  this.$emit("on-sort-change", sortion);
 // }
  get currentRoute() {
    return this.$route;
  }
sortChanged( {column, key, order} ) {
 
      //order值可能为asc，desc，normal（不排序）
   this.model.colTitle=key;
    this.model.orderStyle=order;
    (this.$refs[this.$refsQueryBarName] as any).search();
      }
  @Watch("currentRoute", { deep: true })
  currentRouteChange(route) {
    if (route.name !== this._pageRouteName) return;
    if (route && route.params) {
      var ref = this.$refs[this.$refsQueryBarName] as any;
      if (!!ref) {
        if (route.params.actionCode == "refresh") {
          this.refresh();
        } else if (route.params.actionCode == "reset") {
          (this.$refs[this.$refsQueryBarName] as any).reset();
        }
      }
    }
  }
}
